<template>
  <div class="hero-meta" :class="{ 'hero-meta--no-bb ': border }">
    <div class="hero-meta__title">
      <h1 class="hero-meta__headline--small-bold">{{ title }}</h1>
      <h2  class="hero-meta__headline--large" v-html="tagline"></h2>
    </div>
    <div class="hero-meta__details">
      <div class="hero-meta__detail">
        <div class="work-featured__detail">Category <span>{{ categoryOther || category }}</span></div>
        <div class="work-featured__detail">{{ locationText }} <span>{{ location }}</span></div>
        <div class="work-featured__detail">Client <span>{{ client }}</span></div>
      </div>
      <div class="hero-meta__detail hero-meta__detail-services">
        <div class="work-featured__detail">Services</div>
        <div class="work-featured__detail">
            <span class="services">{{ services }}</span>
        </div>
      </div>
    </div>
    <div 
      class="hero-meta__overview" 
      ref="overviewcontainer"
    >
      <div 
        class="hero-meta__overview-content" 
        v-html="overview" 
        ref="overview"
      ></div> 
      <div 
        class="hero-meta__overview-content hero-meta__overview-content-more" 
        v-html="overviewReadmore" 
        ref="overviewMore"
        :class="{ active : showMoreText }"
      >
      </div>   
    </div>
    <div class="hero-meta__detail-read" v-if="overviewReadmore">
        <svg class="accordion__svg accordion__svg--small black" width="31" height="31" xml:space="preserve" style="enable-background:new 0 0 31 31" viewBox="0 0 31 31">
          <path 
            class="accordion__path accordion__path--v accordion__path--black" 
            d="M15 0h1v31h-1z" 
            fill="black"
            :class="{ 'less': showMoreText }"
          />
          <path class="accordion__path accordion__path--black" d="M0 15h31v1H0z" fill="black"/>
        </svg>
        <button 
          class="btn btn--more-or-less"
          @click="toggleMoreText"
          :class="{ 'less': showMoreText }"
        >
          Read
        </button>
      </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
  props: {
    title: { type: String },
    tagline: { type: String },
    category: { type: String },
    categoryOther: { type: String },
    locationText: { type: String },
    location: { type: String },
    client: { type: String },
    services: { type: String },
    overview: { type: String },
    overviewReadmore: { type: String },
    border: { type: Boolean },
  },
  data() {
    return {
      showMoreText: true,
      defaultHeight: null,
      expandedHeight: null,
    };
  },
  mounted() {
    this.calculateOriginalHeight();
    this.toggleMoreText();
    // setTimeout(() => {
    //   window.addEventListener('resize', this.calculateOriginalHeight);
    // }, 1500);
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calculateOriginalHeight);
  },
  methods: {
    calculateOriginalHeight() {
      this.defaultHeight = (this.$refs.overview.clientHeight + 'px');
      this.expandedHeight = (this.$refs.overview.clientHeight + this.$refs.overviewMore.clientHeight) + 'px';
      console.log(this.defaultHeight);
      console.log(this.expandedHeight);
      this.$refs.overviewcontainer.style.height = this.defaultHeight;
    },
    toggleMoreText() {
      this.calculateOriginalHeight();
      this.$refs.overviewcontainer.style.height = this.showMoreText ? this.defaultHeight : this.expandedHeight;
      this.showMoreText = !this.showMoreText;
    },
  },
};
</script>